<template>
  <div>
    <apexchart
      width="100%"
      height="400"
      type="area"
      :options="areaOptions"
      ref="chart"
      :series="areaOptions.series"
    ></apexchart>
  </div>
</template>
<script>
import VueApexCharts from "vue-apexcharts";
export default {
  name: "Chart",
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    series: {
      type: Array,
      default: () => [],
    },
    period: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      areaOptions: {
        chart: {
          // height: 280,
          type: "area",
          width: "800px",
        },
        annotations: {
          yaxis: [
            {
              y: 30,
              borderColor: "#999",
              label: {
                show: false,
                text: "",
                style: {
                  color: "#fff",
                  background: "#00E396",
                },
              },
            },
          ],
          xaxis: [
            {
              x: new Date().getTime(),
              borderColor: "#999",
              yAxisIndex: 0,
              label: {
                show: false,
                text: "",
                style: {
                  color: "#fff",
                  background: "#775DD0",
                },
              },
            },
          ],
        },
        dataLabels: {
          enabled: false,
        },
        yaxis: {
          labels: {
            formatter: function(value) {
              return value.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              });
            },
          },
        },
        xaxis: {
          type: "datetime",
          min: new Date("01/01/2019").getTime(),
          max: new Date().getTime(),
          tickPlacement: "on",
        },
        tooltip: {
          x: {
            format: "dd MMM yyyy",
          },
          y: {
            formatter: function(value) {
              return value.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              });
            },
          },
        },
        stroke: {
          show: true,
          curve: "smooth",
          width: 2,
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 90, 100],
          },
        },
        series: [],
        colors: [
          "#17a2b8",
          "#3F51B5",
          "#007bff",
          "#28a745",
          "#dc3545",
          "#ffc107",
          "#6F4C5B"
        ],
      },
    };
  },
  watch: {
    series(newVal) {
      this.$refs.chart.updateSeries(newVal);
      this.$refs.chart.zoomX(
        new Date(this.period.start).getTime(),
        new Date(this.period.end).getTime()
      );
    },
  },
};
</script>
